import * as ordersActions from './orders'
import ApiWrapper from '../api/cellWineApi'

export const getOrderList = (query, page, perPage) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.ordersListFailure)
        dispatch(ordersActions.ordersListReq())
        let orderList = await api.getOrderList(query, page, perPage)
        dispatch(ordersActions.ordersListSuccess(orderList))
    }
}

export const getInboundOrderList = (page, perPage) => {
    const query = {
        serviceAction: 'inbound',
        status: 'unpaid',
    }
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getInboundOrdersListFailure)
        dispatch(ordersActions.getInboundOrdersListReq())
        let orderList = await api.getOrderList(query, page, perPage)
        dispatch(ordersActions.getInboundOrdersListSuccess(orderList))
    }
}

export const getOrderItemList = (orderId, page = 1, perPage = 16) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getOrderItemListFailure)
        dispatch(ordersActions.getOrderItemListReq())
        let orderItemList = await api.getOrderItemsList(orderId, page, perPage)
        dispatch(ordersActions.getOrderItemListSuccess({ orderId, orderItemList }))
    }
}

export const getOrderInfo = (orderId) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getOrderInfoFailure)
        dispatch(ordersActions.getOrderInfoReq())
        let order = await api.getOrderInfo(orderId)
        let orderTxnList = await api.getOrderTxnList(orderId)
        order.orderTxnList = [...orderTxnList]
        dispatch(ordersActions.getOrderInfoSuccess(order))
    }
}

export const getUnpaidInboundOrderInfo = (orderId) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getOrderInfoFailure)
        dispatch(ordersActions.getOrderInfoReq())
        let order = await api.getOrderInfo(orderId)
        let orderTxnList = await api.getOrderTxnList(orderId)
        if(order.paymentStatus === 'paid'){
            dispatch(ordersActions.changeRoute({
                path: '/member/order/detail'
            }))
        } else {
            order.orderTxnList = [...orderTxnList]
            dispatch(ordersActions.getOrderInfoSuccess(order))
        }
    }
}

export const getOrderAddress = () => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getOrderAddressFailure)
        dispatch(ordersActions.getOrderAddressReq())
        let address = await api.getOrderHistoryAddress()
        dispatch(ordersActions.getOrderAddressSuccess(address))
    }
}

export const getCoupons = (status, page, perPage) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.listCouponsFailure)
        dispatch(ordersActions.listCouponsReq())
        let coupon = await api.getCouponList(status, page, perPage)
        dispatch(ordersActions.listCouponsSuccess(coupon))
    }
}

export const getCouponProcess = (page, perPage) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getCouponProcessFailure)
        dispatch(ordersActions.getCouponProcessReq())
        let process = await api.getCouponProcess(page, perPage)
        dispatch(ordersActions.getCouponProcessSuccess(process))
    }
}

export const updateOrder = (orderId, data) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.updateOrderFailure)
        dispatch(ordersActions.updateOrderReq())
        const result = await api.updateOrder(orderId, data)
        dispatch(ordersActions.updateOrderSuccess(result))
    }
}

export const orderCreditCardPayment = (orderId, data) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.orderCreditCardPaymentFailure)
        dispatch(ordersActions.orderCreditCardPaymentReq())
        await api.orderCreditCardPayment(orderId, data)
        dispatch(ordersActions.orderCreditCardPaymentSuccess())
    }
}

export const updateShippingCart = (memberWineIds) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.updateShippingCartFailure)
        dispatch(ordersActions.updateShippingCartReq())
        await api.updateShippingCart(memberWineIds)
        dispatch(getShippingCartList())
    }
}

export const getShippingCartList = (page = 1, perPage = 100) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.getShippingCartFailure)
        dispatch(ordersActions.getShippingCartReq())
        let shippingCart = await api.getShippingCartList(page, perPage)
        dispatch(ordersActions.getShippingCartSuccess(shippingCart))
        let fee = await api.getFeeConstant()
        dispatch(ordersActions.getFeeSuccess(fee))
    }
}

export const createShippingOrder = (order, shouldPay) => {
    return async (dispatch) => {
        let api = new ApiWrapper(dispatch, ordersActions.createShippingOrderFailure)
        dispatch(ordersActions.createShippingOrderReq())
        let res = await api.createShippingOrder(order)
        if(shouldPay){
            dispatch(orderCreditCardPayment(res.id))
        }
        dispatch(ordersActions.createShippingOrderSuccess({
            ...order,
            ...res
        }))
    }
}